module.exports = __webpack_public_path__ + "static/media/brain.d3943a44.png";